module.exports = __webpack_public_path__ + "static/media/cryths.8eeffd69.svg";